import {
  required, integer, minLength,
} from 'vuelidate/lib/validators';

const states = [
  'ACT',
  'NSW',
  'NT',
  'QLD',
  'SA',
  'TAS',
  'VIC',
  'WA',
];

export default {
  name: 'property-details-address',
  data: () => ({
    states,
  }),
  computed: {
    streetAddress: {
      get() {
        return this.$store.getters['toolkit/getItemData'].property.address.street;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { property: { address: { street: value } } } });
      },
    },
    suburb: {
      get() {
        return this.$store.getters['toolkit/getItemData'].property.address.suburb;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { property: { address: { suburb: value } } } });
      },
    },
    state: {
      get() {
        return this.$store.getters['toolkit/getItemData'].property.address.state;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { property: { address: { state: value } } } });
      },
    },
    postcode: {
      get() {
        return this.$store.getters['toolkit/getItemData'].property.address.postCode;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { property: { address: { postCode: value } } } });
      },
    },
  },
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function isComponentValid(value) {
        this.$emit('valid', !value);
      },
    },
  },
  validations: {
    streetAddress: {
      required,
    },
    suburb: {
      required,
    },
    state: {
      required,
    },
    postcode: {
      required,
      integer,
      minLength: minLength(4),
    },
  },
};
